import apiClient from './apiClient';

const login = async (email, password) => {
    try {
        const response = await apiClient.post('auth/login', { email, password });
        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(error.response?.data?.error || error.message)
    }
};

const register = async (userData) => {
    try {
        const response = await apiClient.post('auth/register', userData);
        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(error.response?.data?.error || error.message)
    }
};

// Agrupamos los servicios en un objeto
const authService = {
    login,
    register,
};

export default authService;